import { z } from 'zod';

export const getErrorMessages = <K extends z.Schema>({
  errorMessages,
  schema,
}: {
  errorMessages: string[];
  schema: K;
}) => {
  const checkValue = (value: z.infer<K>) => {
    const checksState = schema.safeParse(value);

    if (checksState.success)
      return errorMessages.map((message) => ({
        fatal: false,
        message,
      }));

    const errorState = checksState.error.issues;

    return errorMessages.map((message) => ({
      fatal: errorState.find((error) => error.message === message),
      message,
    }));
  };
  return { checkValue };
};
